module.exports = __webpack_public_path__ + "static/media/happy_girl.1913cf9e.jpg";